/* eslint-disable complexity */
/* eslint-disable max-statements */
import React from "react";
import PropTypes from "prop-types";
import { COMPONENT_MAPPING } from "./selector";

const ElitePageLayout = ({
    cmsData
}) => {
    const { otherSections } = cmsData || {};

    return (
        <React.Fragment>
            {
                otherSections.map((section, index) => {
                    const Component = COMPONENT_MAPPING[section.pageSection.name];
                    return Component ? <Component key={`elite-${index}`} section={section} /> : null;
                })
            }
        </React.Fragment>
    );
};

ElitePageLayout.propTypes = {
    cmsData: PropTypes.object
};

export default ElitePageLayout;
